module.exports = __webpack_public_path__ + "static/media/panzer_regiment_120.250dd9a2.png";